<div class="stl-viewer-wrapper">
  <canvas #canvas></canvas>
  <div class="stl-overlay" *ngIf="loading">
    <mat-icon class="spin">refresh</mat-icon>
  </div>
  <div class="stl-overlay stl-error" *ngIf="errorMsg">
    <mat-icon>broken_image</mat-icon>
    <span>{{errorMsg}}</span>
  </div>
  <div class="stl-hint" *ngIf="!loading && !errorMsg">
    <mat-icon style="font-size:12px; width:12px; height:12px;">360</mat-icon>
    <span>Arrastra para rotar</span>
  </div>
</div>
